import React from "react";
//#region redux
//#region  types
import { TranslationKeys } from "translations";
import { EventConstants } from "utils/constants";
import { ComponentBaseProps } from "models/propTypes/basePropTypes";
//#endregion
//#region  components
import { Grid, Skeleton } from "@mui/material";
import lazyWithReload from "utils/lazyWithReload";
import TodoChipContainer from "./chipContainer";
import useTodosFromState from "components/todos/useTodosFromState";
//#endregion
import clsx from "clsx";
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance, EventHelper } from "utils/helpers";

const BannerImageLazy = lazyWithReload(() => import("./urgentStateBannerImage"));

const UrgentStateWidget: React.FC<ComponentBaseProps> = (props) => {
  const { todoCount, items } = useTodosFromState();
  const mostUrgentTodoItem = items ? items[0] : undefined;

  const openTodoDrawer = () => {
    EventHelper.publishEvent(EventConstants.ToggleNotifications);
  };

  return todoCount !== undefined && todoCount > 10 ? (
    <Grid
      item
      container
      className={clsx(cssExports.stateBannerContainer, cssExports.urgentBannerContainer, props.className)}
      direction="row"
    >
      <Grid item className={cssExports.bannerImgContainer}>
        <React.Suspense fallback={<Skeleton width={148} style={{ background: "transparent" }}></Skeleton>}>
          <BannerImageLazy />
        </React.Suspense>
      </Grid>
      <Grid item xs={12} sm container alignItems="center">
        <Grid item container direction="column">
          <Grid item className={cssExports.bannerHeaderText}>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.UrgentStateTitle)}
          </Grid>
          <Grid item className={cssExports.bannerDescription}>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.UrgentStateText)}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm container alignItems="center" className={cssExports.bannerTodoChips}>
        {mostUrgentTodoItem !== undefined ? (
          <Grid item container spacing={1} direction="column" onClick={openTodoDrawer.bind(null)}>
            <TodoChipContainer todo={mostUrgentTodoItem} />
          </Grid>
        ) : (
          <></>
        )}
      </Grid>
    </Grid>
  ) : (
    <></>
  );
};

export default UrgentStateWidget;
